import React from 'react'
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';

const SideBar = () => {
    const navigate = useNavigate();

    function handleLogout() {
        toast.warning("Logged Out");
        localStorage.clear();
        navigate("/");

    }
    return (
        <>
            
                <aside id="sidebar" className="sidebar">

                    <ul className="sidebar-nav" id="sidebar-nav">
                        <li className="nav-item">
                            <Link className='nav-link' to='dashboard'>
                                <i className="bi bi-grid"></i>
                                <span>Dashboard</span>
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                        <Link className='nav-link' to='sale'>
                            <i className="bi bi-grid"></i>
                            <span>Temp Sale</span>
                        </Link>
                    </li> */}
                        <li className="nav-item">
                            <Link className='nav-link' to='products'>
                                <i className="bi bi-grid"></i>
                                <span>Products</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-link' to='sales'>
                                <i className="bi bi-grid"></i>
                                <span>Sales</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-link' to='/'>
                                <i className="bi bi-grid"></i>
                                <span>
                                <div onClick={() => { handleLogout() }}>Logout</div>    
                                </span>
                            </Link>
                        </li>
                        

                    </ul>

                </aside>
            

        </>
    )
}

export default SideBar